import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const gamification: PartialTranslation["gamification"] = {
  streak: {
    modalTitle: "Chi tiết chuỗi",
    days_one: "Chuỗi {{count}} ngày",
    days_other: "Chuỗi {{count}} ngày",
    dayWord: "ngày",
    none: "Chưa có chuỗi nào",
    longest: "Dài nhất {{count}}",
    freezes_one: "{{count}} lượt đóng băng",
    freezes_other: "{{count}} lượt đóng băng",
    xpWord: "XP",
    sections: "Các mục của chuỗi",
    activeDays_one: "{{count}} ngày hoạt động",
    activeDays_other: "{{count}} ngày hoạt động",
    previousMonth: "Tháng trước",
    nextMonth: "Tháng sau",
    legendLess: "Ít hơn",
    legendMore: "Nhiều hơn",
    legendFreeze: "Đóng băng",
    legendMilestone: "Cột mốc",
    daysToMilestone_one: "Còn {{count}} ngày nữa để đạt {{badge}}",
    daysToMilestone_other: "Còn {{count}} ngày nữa để đạt {{badge}}",
    next: "Tiếp theo",
    loading: "Đang tải hoạt động…",
    loadingMilestones: "Đang tải các cột mốc…",
    loadingChallenges: "Đang tải thử thách…",
    freezesTitle: "Lượt đóng băng",
    freezesUsed: "Đã dùng {{count}} lần",
    freezesAvailable: "Còn {{count}} trên {{max}} lượt đóng băng",
    freezeExplanation:
      "Một lượt đóng băng được dùng tự động vào ngày bạn bỏ lỡ, giúp chuỗi không bị đứt. Hãy tích lũy từ các cột mốc.",
  },
  challenges: {
    title: "Thử thách hằng ngày",
    empty: "Thử thách hôm nay đang được chuẩn bị. Hãy quay lại sau.",
    open: "Mở thử thách này",
    minutesShort: "phút",
    default: "Thử thách hằng ngày",
    vocabulary_review: "Ôn tập từ vựng",
    practice_topic: "Luyện tập một chủ đề",
    create_topic: "Tạo một chủ đề",
    study_time: "Thời gian học",
    video_shadowing: "Nói theo video",
    video_dictation: "Chép tay theo video",
  },
};